import {useEffect, useState} from "react";
import BodyContainer from "../components/BodyContainer";
import Title from "../components/Title";
import ProgressRing from "../components/ProgressRing";
import {useParams} from "react-router-dom";
import {getSchedule} from "../handlers/schedulehandler";
import ScheduleItemForView, {getParticipantString, getTitleString} from "../components/ScheduleItemForView";
import {Button, Input} from "@fluentui/react-components";
import {ArrowClockwise16Regular, Dismiss16Regular, DismissRegular, Search16Regular} from "@fluentui/react-icons";
import Schedule from "../models/Schedule";

const ScheduleView = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [schedule, setSchedule] = useState(null);
    const [searchedSchedule, setSearchedSchedule] = useState(null);
    const [searchValue, setSearchValue] = useState("");

    const fetchEventSchedule = async () => {
        const result = await getSchedule(id);
        setSchedule(result);
        setSearchedSchedule(result);
    }

    const searchSchedule = (searchValue) => {
        setSearchValue(searchValue);

        if (searchValue === "") {
            setSearchedSchedule([...schedule]);
            return;
        }

        let localSchedule = [];

        for (const scheduleItem of schedule) {
            if (!scheduleItem || !(scheduleItem instanceof Schedule)) {
                continue
            }

            if (sanitizeSearchObjects(getTitleString(scheduleItem)).includes(sanitizeSearchObjects(searchValue))) {
                localSchedule.push(scheduleItem);
                continue;
            }

            for (const participantItem of scheduleItem?.participants) {
                if (sanitizeSearchObjects(getParticipantString(participantItem.participants)).includes(sanitizeSearchObjects(searchValue))) {
                    localSchedule.push(scheduleItem);
                    break;
                }
            }
        }

        setSearchedSchedule(localSchedule);
    }

    const sanitizeSearchObjects = (searchValue) => {
        return searchValue.replaceAll("-", " ").replaceAll(" ", "").toLowerCase();
    }

    useEffect(() => {
        setIsLoading(true);
        fetchEventSchedule().then(() => {
            setIsLoading(false);
        })
    }, []);

    return (
        <BodyContainer showBackButton={true} content={
            <>
                <Title title={`Wedstrijdschema`} />
                { isLoading && <ProgressRing/> }
                { !isLoading && !searchedSchedule && <p>Er is geen wedstrijdschema beschikbaar.</p> }
                { !isLoading && searchedSchedule != null &&
                    <>
                        <Input type={"text"}
                               value={searchValue}
                               onChange={(event) => searchSchedule(event.target.value)}
                               placeholder={"Zoek naar deelnemers, wedstrijden en meer..."}
                               contentBefore={<Search16Regular/>}
                               contentAfter={
                                    searchValue !== "" ?
                                        <Button as={`a`}
                                                className={`button`}
                                                appearance={`subtle`}
                                                icon={<Dismiss16Regular/> }
                                                onClick={() =>searchSchedule("")}/>
                                        : null }
                        />

                        <div className={`flex`}>
                            <Button as={`a`} className={`button`} appearance={"secondary"} onClick={fetchEventSchedule} >
                                <ArrowClockwise16Regular/> Reload
                            </Button>
                        </div>
                        {
                            (searchedSchedule).map((scheduleItem, index) => (
                                <ScheduleItemForView scheduleItem={scheduleItem} key={index} />
                            ))
                        }
                    </>
                }
            </>
        } />
    );
}

export default ScheduleView;